module.exports = __webpack_public_path__ + "images/placeholder_portail.fccee7b7.png";